module.exports = __webpack_public_path__ + "img/maintenance.822b8ac1.svg";